import Router from '@/router'
import cookies from 'js-cookie'
import { Toast } from 'vant'
import { removeMeet } from './score'

const KEY_TOKEN = 'mobile_score_token'

export function getToken() {
  const ssToken = sessionStorage.getItem(KEY_TOKEN)
  const lsToken = localStorage.getItem(KEY_TOKEN)
  const cookieToken = cookies.get(KEY_TOKEN)
  const token = ssToken || lsToken || cookieToken
  if (token && (!ssToken || !lsToken || !cookieToken)) {
    setToken(token)
  }
  return token
}

export function setToken(value) {
  cookies.set(KEY_TOKEN, value, { expires: 7 })
  sessionStorage.setItem(KEY_TOKEN, value)
  localStorage.setItem(KEY_TOKEN, value)
}

export function logout(message) {
  if (message) {
    Toast({ position: 'bottom', message })
  }
  Router.push({ name: 'login' })
  cookies.remove(KEY_TOKEN)
  localStorage.removeItem(KEY_TOKEN)
  sessionStorage.removeItem(KEY_TOKEN)
  removeMeet()
  window.location.reload()
}
